import { styled } from 'baseui'

export const PollCard = styled('div', ({ $theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '0.625rem',
  marginTop: '0.125rem',
  marginBottom: '0.125rem',
  paddingTop: '0.75rem',
  paddingBottom: '0.75rem',
  paddingLeft: '0.75rem',
  paddingRight: '0.75rem',
  backgroundColor: $theme.colors.bgPulseCanvas,
  border: `1px solid ${$theme.colors.borderPulseCard}`,
  borderRadius: '0.75rem',
}))

export const PollQuestion = styled('span', ({ $theme }) => ({
  fontSize: '0.8125rem',
  lineHeight: '1.35',
  fontWeight: 600,
  color: $theme.colors.textPulseStrong,
}))

export const PollStatus = styled('span', ({ $theme }) => ({
  fontSize: '0.75rem',
  lineHeight: '1rem',
  color: $theme.colors.textPulseMuted,
}))
